import { combineReducers } from 'redux';
import { authReducer } from './reducers/auth';
import { common } from "./reducers/common/common";
import { cartReducer } from './reducers/cart';


export default combineReducers({
    auth: authReducer,
    common: common,
    cart: cartReducer,
   
});



